import { render, staticRenderFns } from "./PropertiesSearch2024.vue?vue&type=template&id=55f6e2bd"
import script from "./PropertiesSearch2024.vue?vue&type=script&lang=js"
export * from "./PropertiesSearch2024.vue?vue&type=script&lang=js"
import style0 from "./PropertiesSearch2024.vue?vue&type=style&index=0&id=55f6e2bd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports